import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../../routes";
import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { Badge } from "primereact/badge";
import Authentification from "../../../api/Authentification";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";

import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextInput } from "../../formLibs/FormLibs";
import { ErrorMsg } from "../../includes/styles/Styles";
import { Toast } from "primereact/toast";
import DeleteConfirmation from "../../modal/DeleteConfirmation";

export default function Header({ onClick, navWidth }) {
  const [loading, setLoading] = useState(false);
  const menuRight = useRef(null);
  const [user, setUser] = useState("");
  const [addVisible, setAddVisible] = useState(false);
  const [typeFieldPassword, setTypeFieldPassword] = useState(false);
  const [iconPassword, setIconPassword] = useState(false);
  const toast = useRef(null);
  const [confirm, setConfirm] = useState(false);
  const rejectConfirmation = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulé",
      detail: "Vous aviez annulé la déconnexion",
      life: 3000,
    });
  };
  const logoutUser = () => {
    Authentification.logout();
    setConfirm(false);
  };
  useEffect(() => {
    Authentification.getCurrentUser()
      .then((res) => {
        setUser(res.data.user);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  const profil = [
    {
      label: user ? user?.firstname + " " + user?.lastname : "",
      items: [
        {
          label: routes.dashboard.profil.name,
          icon: routes.dashboard.profil.icon,
          url: routes.dashboard.profil.path,
          command: (e) => {
            console.log("mon profil");
          },
        },
        {
          label: "Changer mot de passe",
          icon: <span className="pi pi-lock"></span>,
          //url: routes.dashboard.profil.path,
          command: (e) => {
            setAddVisible(true);
          },
        },
        {
          label: "Se déconnecter",
          icon: "pi pi-upload",
          command: (e) => {
            setConfirm(true);
          },
        },
      ],
    },
  ];

  const schema = Yup.object({
    oldPassword: Yup.string().required("L'ancien mot de passe est obligatoire"),
    newPassword: Yup.string()
      .required("Le nouveau mot de passe est obligatoire")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&-+=()!]).{8,24}$/,
        { message: "Mot de passe trop faible" }
      ),
    password_confirmation: Yup.string()
      .required("Confirmez le nouveau mot de passe")
      .oneOf([Yup.ref("password"), null], "Mot de passe différent"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(schema) });

  const handleCLickIconPasswords = (e) => {
    e.preventDefault();
    setIconPassword(!iconPassword);
    setTypeFieldPassword(!typeFieldPassword);
  };

  const changePassword = (data) => {
    setLoading(true);
    Authentification.updatePassword(data)
      .then((res) => {
        if (res.data.error) {
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Ancien mot de passe incorrect",
            life: 3000,
          });
          setLoading(false);
        } else {
          toast.current.show({
            severity: "success",
            summary: "Succès",
            detail: "Mot de passe modifié avec succès",
            life: 5000,
          });
          reset();
          setAddVisible(false);
          setLoading(false);
        }
      })
      .catch(() => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Ancien mot de passe incorrect",
          life: 3000,
        });
        setLoading(false);
      });
  };

  return (
    <>
      <Toast ref={toast} />
      <DeleteConfirmation
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={`Voulez-vous réellement vous déconnecté ?`}
        accept={logoutUser}
        reject={rejectConfirmation}
        header={"Confirmation de déconnexion"}  
        acceptClassName={"p-button-danger"}
      />
      <Dialog
        header="Modifier mot de passe"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={handleSubmit(changePassword)}>
          <div className="form__item">
            <label htmlFor="password">Ancien mot de passe</label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="oldPassword"
                label="oldPassword"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <a
                href="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </a>
            </div>
            <ErrorMsg>{errors.oldPassword?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="newPassword">Nouveau mot de passe</label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="newPassword"
                label="newPassword"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <a
                href="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </a>
            </div>
            <ErrorMsg>{errors.newPassword?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="password_confirmation">
              Confirmer nouveau mot de passe
            </label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="password_confirmation"
                label="password_confirmation"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <Link
                to="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </Link>
            </div>
            <ErrorMsg>{errors.password_confirmation?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <nav className={`nav ${navWidth}`}>
        <div className="nav__inner">
          <div className="nav__left">
            <div onClick={onClick} style={{ cursor: "pointer" }}>
              <i className="pi pi-align-left"></i>
            </div>
          </div>
          <div className="nav__right">
            <div>
              <Link>
                <i
                  className="pi pi-bell p-overlay-badge mt-2"
                  style={{ fontSize: "1.5rem" }}
                >
                  {/*<Badge value="2"></Badge>*/}
                </i>
              </Link>
            </div>
            <Avatar
              label={
                user
                  ? user?.firstname?.charAt(0) + user?.lastname?.charAt(0)
                  : ""
              }
              style={{ backgroundColor: "#9c27b0", color: "#ffffff" }}
              shape="circle"
              onClick={(event) => menuRight.current.toggle(event)}
              aria-controls="popup_menu_right"
              aria-haspopup
            />
            <Menu
              model={profil}
              popup
              ref={menuRight}
              id="popup_menu_right"
              popupAlignment="right"
            />
          </div>
        </div>
      </nav>
    </>
  );
}
